import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import { Backdrop } from '@mui/material';
import Loader from '../../components/loader/Loader';

const Loading = ({ open = true }) => (
  <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1,backgroundColor:'rgba(0,0,0,0.50)' }} open={Boolean(open)}>
    <Loader size={60} />
  </Backdrop>
);

Loading.propTypes = {
  open: PropTypes.bool,
};

export default Loading;
